export function publicUrl(path) {
  const base = (import.meta?.env?.BASE_URL || "/").toString();
  const baseNorm = base.endsWith("/") ? base : `${base}/`;
  const p = String(path || "").replace(/^\/+/, "");
  return `${baseNorm}${p}`;
}

